import _ from 'lodash'
import { call, put, select, fork } from 'redux-saga/effects'

import { updateSumAssured } from 'quick-quote/product-common/coverage-plan/actions'
import * as productCommonCoveragePlan from 'quick-quote/product-common/coverage-plan/actions'
import * as productSelection from 'quick-quote/product-selection/actions'
import { partnerRequesting } from 'quick-quote/actions'

import { getSumAssured$, getSumAssured } from 'quick-quote/product-common/coverage-plan/selectors'
import { getBoosterSA } from 'quick-quote/product-life-protect-plus/selectors'
import { getSelectedDisplayProductCode, getSelectedDisplayProduct } from 'quick-quote/product-selection/selectors'

import VALUES from 'core/data-model/constants/values'
import { valid } from 'core/service/lib/check'

/**
 * createProductLifeProtectPlusHandler
 * @param productCommonService {ReturnType<import('./product-common').createProductCommonService>}
 */
export function createProductLifeProtectPlusService(productCommonService) {
  function onUpdateSwitchPlanLifeProtectPlus(productGroup) {
    return function* (action) {
      if (['LIFE_PROTECT_PLUS'].includes(productGroup)) {
        const boosterSA = yield select(getBoosterSA)
        const productCodeWithBoosterSA = selectedLifeProtectPlusCorrectPlanWithBoosterSA(
          action.payload,
          boosterSA.boosterPlan
        )

        const comingDisplayProduct = productCommonService.getDisplayProductFromCache(productCodeWithBoosterSA)
        if (comingDisplayProduct) {
          yield call(onSwitchProductLifeProtectPlus, comingDisplayProduct)
        }
      }
    }
  }

  function onSelectBoosterPlan(productGroup) {
    return function* (action) {
      if (['LIFE_PROTECT_PLUS'].includes(productGroup)) {
        const productCode = yield select(getSelectedDisplayProductCode)
        const productCodeWithBoosterSA = selectedLifeProtectPlusCorrectPlanWithBoosterSA(productCode, action.payload)

        const comingDisplayProduct = productCommonService.getDisplayProductFromCache(productCodeWithBoosterSA)
        if (comingDisplayProduct) {
          yield call(onSwitchProductLifeProtectPlus, comingDisplayProduct)
        }
      }
    }
  }

  function* onSwitchProductLifeProtectPlus(comingDisplayProduct) {
    const previousDisplayProduct = yield select(getSelectedDisplayProduct)
    let updateComingDisplayProduct = comingDisplayProduct

    const comingProduct = yield call(productCommonService.findAvailableInProductGroup, {
      selectedDisplayProduct: comingDisplayProduct,
    })
    if (comingProduct) {
      updateComingDisplayProduct = comingProduct
    }

    // update select modal factor
    // yield call(productCommonService.defaultSelectModalFactor, updateComingDisplayProduct)

    const isProductChanged =
      previousDisplayProduct.code === '' || previousDisplayProduct.code !== updateComingDisplayProduct.code

    if (isProductChanged) {
      yield put(
        updateSumAssured(
          valid(updateComingDisplayProduct.defaultSumAssured ?? updateComingDisplayProduct.sumAssuredMinimum)
        )
      )
    }

    yield put(productSelection.changeProduct(updateComingDisplayProduct))

    if (previousDisplayProduct.code !== '' && previousDisplayProduct.code !== updateComingDisplayProduct.code) {
      yield put(partnerRequesting('change_product'))

      const comingAvailableRiders = yield call(
        productCommonService.getAvailableRiderByBasicPlanCode,
        updateComingDisplayProduct,
        false
      )
      yield put(productCommonCoveragePlan.updateAvailableRiders(comingAvailableRiders))

      yield fork(productCommonService.calculateWithValidation)
    }
  }

  function selectedLifeProtectPlusCorrectPlanWithBoosterSA(productCode, boosterPlan) {
    if (boosterPlan === VALUES.BOOSTER_SA_PLAN.FIFTY_PERCENT) {
      switch (productCode) {
        case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_9_UNDER:
        case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_9_HIGHER:
          return VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_9_UNDER
        case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_19_UNDER:
        case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_19_HIGHER:
          return VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_19_UNDER
        case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_99_UNDER:
        case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_99_HIGHER:
          return VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_99_UNDER
        default:
          return productCode
      }
    } else if (boosterPlan === VALUES.BOOSTER_SA_PLAN.ONE_HUNDRED_PERCENT) {
      switch (productCode) {
        case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_9_UNDER:
        case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_9_HIGHER:
          return VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_9_HIGHER
        case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_19_UNDER:
        case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_19_HIGHER:
          return VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_19_HIGHER
        case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_99_UNDER:
        case VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_99_HIGHER:
          return VALUES.LIFEPROTECT_PLUS_CODE.LIFEPROTECT_PLUS_99_HIGHER
        case VALUES.COMBO_CI_LIFEPROTECT_PLUS_CODE.WLF19H:
        case VALUES.COMBO_HEALTH_ESSENTIAL_LIFEPROTECT_PLUS_CODE.WLF19H:
        case VALUES.COMBO_CI_LIFEPROTECT_PLUS_CODE.WLF99H:
        case VALUES.COMBO_HEALTH_ESSENTIAL_LIFEPROTECT_PLUS_CODE.WLF99H:
          return productCode
        default:
          return productCode
      }
    } else {
      return productCode
    }
  }

  return {
    onUpdateSwitchPlanLifeProtectPlus,
    onSelectBoosterPlan,
  }
}
